import type { Step } from '../types/step';
import { StepCategory } from '../../types/app_data';
import { isRefiQualified } from '../../utils/app_data';

/**
 * When Refi is selected and there are more than one car, ask which car to loan.
 * This is used when both insurance and refi are selected.
 */
export const RefiCarsStep: Step = {
  id: 'askRefiCars',
  pathname: '/reficars',
  canShow: (appData) => {
    const selectedCars = appData.selectedCars || [];
    // Only ask if user selected refi service and is qualified and user has more than one car
    return !!appData.serviceSplitSelectedService?.refi && isRefiQualified(appData) && selectedCars.length > 1;
  },
  hasData: () => true,
  hasOwnData: () => true,
  category: () => StepCategory.Cars,
};
